import React from 'react';

import BumoCarousel from './BumoCarousel';
import Dots from './Dots';
import { InnerContainer } from './Layout';
import { HeaderSlide, HeaderSlideConfig } from './headerV2/HeaderSlide';
import SymbolsDefs from './headerV2/SymbolsDefs';
import { useAutoProgress } from './headerV2/useAutoProgress';
import FeatureFlags from '../constants/FeatureFlags';
import { useMaxWidth } from '../hooks/useResponsive';

const defaultOptions = {
  e: 'improve',
  w: '600',
  h: '410',
  c: 'fill',
  g: 'auto',
};
export const getCloudinaryImageUrl = (
  publicID: string,
  options: Partial<typeof defaultOptions> = {}
) => {
  return `https://res.cloudinary.com/dfeukorpg/image/upload/${Object.entries({
    ...defaultOptions,
    ...options,
  })
    .map(([key, value]) => `${key}_${value}`)
    .join(',')}/${publicID}`;
};

const itemsConfig: HeaderSlideConfig[] = (FeatureFlags.SUMMER_CAMP_HEADERS_V2
  ? window.customCtx?.ctxSummerCampConfig?.banner
  : undefined) || [
  {
    bgColor: '#F5AF76',
    photoUrl: getCloudinaryImageUrl(
      '5c86ead9614290ccb66dc9b32ac92de3_gi5xqx.png'
    ),
    photoAltText: '**Hawks Nature Camp**, Multiple locations, CA',
    title: 'Summer Care and Camps',
    description: `Adventure awaits! From outdoor exploration to STEM, arts and crafts, Bumo's diverse summer camps spark curiosity in every child. Book today.`,
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#FEEB73',
      },
      {
        href: '#palm',
        x: 381,
        y: 296,
        width: '96',
        height: '96',
        fill: '#B6EEAB',
      },
      {
        href: '#berry',
        x: 413,
        y: 10,
        width: '108',
        height: '117',
        fill: '#FA3088',
      },
      {
        href: '#watermelon',
        x: 129,
        y: 296,
        width: 96,
        height: 96,
        fill: '#E2226B',
      },
    ],
    mainDecor: {
      href: '#palm',
      // x: 381,
      // y: 296,
      width: '96',
      height: '96',
      fill: '#B6EEAB',
    },
  },
  {
    bgColor: '#D0E5CC',
    photoUrl: getCloudinaryImageUrl(
      'c972aa316b296401d7dbeb42c9498406_cbkjhr.png'
    ),
    photoAltText: '**Code Ninjas**, Newport Beach, CA',
    title: 'STEM & Coding Camps',
    description: `Flexible instantly bookable camps for scientists and future innovators from K through 12.`,
    mainDecor: {
      href: '#device',
      fill: '#E2226B',
    },
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#F46234',
      },
      {
        href: '#device',
        x: 120,
        y: 286,
        width: 90,
        height: 90,
        fill: '#E2226B',
      },
      {
        href: '#laptop',
        x: 465,
        y: 34,
        width: 116,
        height: 116,
        fill: '#FA3088',
      },
      {
        href: '#router',
        width: 103,
        height: 103,
        x: 366,
        y: 289,
        fill: '#F5AF76',
      },
    ],
  },
  {
    bgColor: '#FEEB73',
    photoUrl: getCloudinaryImageUrl(
      '34d996785f5085b040305d370cd1fc77_mrc47b.png'
    ),
    photoAltText: '**Eco Atelier**, Los Angeles, CA',
    title: 'Arts & Crafts Camp',
    description: `Book half-day or full-day camps for creative minds pre-K to 12.`,
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#F5AF76',
      },
      {
        href: '#palette',
        x: 416,
        y: 15,
        width: 100,
        height: 100,
        fill: '#FA3088',
      },
      {
        href: '#cut',
        x: 120,
        y: 286,
        width: 90,
        height: 90,
        fill: '#E2226B',
      },
      {
        href: '#camera',
        x: 384,
        y: 299,
        width: 80,
        height: 80,
        fill: '#2B9B58',
      },
    ],
    mainDecor: {
      href: '#camera',
      fill: '#2B9B58',
    },
  },
  {
    bgColor: '#B3D3D6',
    photoUrl: getCloudinaryImageUrl(
      '6d775e3070d97f98d88b0c4ed8c8a301_igej5j.png'
    ),
    photoAltText: '**Aqua Surf Camp**, Multiple Locations, CA',
    title: 'Sports & Outdoor Camps',
    description: `Book drop-in camps for adventure seekers and athletes K through 12.`,
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#F5AF76',
      },
      {
        href: '#pets',
        fill: '#FEEB73',
        width: 90,
        height: 90,
        x: 438,
        y: 14,
      },
      {
        href: '#watermelon',
        x: 129,
        y: 296,
        width: 96,
        height: 96,
        fill: '#E2226B',
      },
      {
        href: '#pool',
        x: 384,
        y: 299,
        width: 80,
        height: 80,
        fill: '#2E5394',
      },
    ],
    mainDecor: {
      href: '#pool',
      fill: '#2E5394',
    },
  },
  {
    bgColor: '#F8C1D9',
    photoUrl: getCloudinaryImageUrl(
      'b06632d6aa1a161ac9b2ef9cf2bab00d_dhjpun.png'
    ),
    photoAltText: '**Wonder Years Preschool Summer Camp**, West LA, CA',
    title: 'Preschool & Toddler Camps',
    description: `Continued socialization and kinder readiness awaits with drop-in preschool and toddler camps.`,
    decors: [
      {
        href: '#stars',
        x: 40,
        y: 40,
        width: 55,
        height: 55,
        fill: '#FEEB73',
      },
      {
        href: '#watermelon',
        x: 129,
        y: 296,
        width: 96,
        height: 96,
        fill: '#E2226B',
      },
      {
        href: '#berry',
        x: 413,
        y: 10,
        width: 108,
        height: 117,
        fill: '#FA3088',
      },
      {
        href: '#beach',
        x: 384,
        y: 299,
        width: 100,
        height: 100,
        fill: '#B6EEAB',
      },
    ],
    mainDecor: {
      href: '#beach',
      fill: '#B6EEAB',
    },
  },
];

export default function ConnectedSummerCampHeader() {
  const { activeIndex, setActiveIndex } = useAutoProgress(
    itemsConfig.length,
    6000
  );

  const slidesAmount = itemsConfig.length;

  const isMobileDevice = useMaxWidth(800);

  return (
    <InnerContainer style={{ overflow: 'hidden', marginTop: 50 }}>
      <BumoCarousel
        renderedElements={1}
        activeIndex={activeIndex}
        onIndexChange={setActiveIndex}
        // itemContainerStyle={{ padding: 10 }}
        showArrows={false}
        containerStyle={{ marginBottom: 20, overflow: 'hidden' }}
      >
        {itemsConfig.map((item, index) => (
          <HeaderSlide key={index} config={item} mobile={isMobileDevice} />
        ))}
      </BumoCarousel>
      <Dots
        activeIndex={activeIndex}
        amount={slidesAmount}
        dotProps={{
          inactiveColor: '#ddd',
        }}
      />
      <SymbolsDefs />
    </InnerContainer>
  );
}
